import React from 'react'
import styled from 'styled-components'
import Author from './Author/Author'
const config = require('../../utils/siteConfig')
import amazon from './amazon.png'
import twitter from './twitter.png'

const MailChimp = () => {
  return (
    <div id="mc_embed_signup">
      <form
        action="https://dotnetsurfers.us6.list-manage.com/subscribe/post?u=91077874a29147366fcb60439&amp;id=b91df5f147"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        className="validate"
        target="_blank"
        novalidate
      >
        <div id="mc_embed_signup_scroll">
          <label for="mce-EMAIL">Receive updates via email</label>
          <input
            type="email"
            name="EMAIL"
            className="email"
            id="mce-EMAIL"
            placeholder="email address"
            required
          />
          <input
            type="submit"
            value="Subscribe"
            name="subscribe"
            id="mc-embedded-subscribe"
            className="button"
          />
          <div id="mc_input_2" aria-hidden="true">
            <input
              type="text"
              name="b_91077874a29147366fcb60439_b91df5f147"
              tabindex="-1"
              value=""
            />
          </div>
        </div>
      </form>
    </div>
  )
}

const Wrapper = styled.article`
  max-width: ${props => props.theme.post.sizes.maxWidth};
  margin: 0 auto;

  a {
    border-bottom: 1px solid ${props => props.theme.post.colors.linkHover};
    color: ${props => props.theme.post.colors.link};
    font-weight: bold;
    text-shadow: 2px 2px ${props => props.theme.post.backgrounds.wrapper},
      -2px 2px ${props => props.theme.post.backgrounds.wrapper},
      -2px -2px ${props => props.theme.post.backgrounds.wrapper},
      -2px 2px ${props => props.theme.post.backgrounds.wrapper},
      -2px 0 ${props => props.theme.post.backgrounds.wrapper},
      2px 0 ${props => props.theme.post.backgrounds.wrapper};
    display: inline-block;
    line-height: 1.1;
    text-decoration: none;
    transition: 0.3s;

    &:hover {
      color: ${props => props.theme.post.colors.linkHover};
      border-color: ${props => props.theme.post.colors.link};
    }
  }
`

const Header = styled.header``

const Title = styled.h1`
  color: ${props => props.theme.post.colors.title};
  font-size: 1.9em;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1;
  margin: 0 0 0.4em;

  @media screen and (min-width: ${props => props.theme.mediaQueryTresholds.M}) {
    font-size: 2.6em;
    letter-spacing: -0.03em;
  }
  @media screen and (min-width: ${props =>
      props.theme.mediaQueryTresholds.XL}) {
    font-size: 3.2em;
    letter-spacing: -0.04em;
  }
`

const SubTitle = styled.h2`
  color: ${props => props.theme.post.colors.subTitle};
  font-size: 1.5em;
  font-weight: 300;
  line-height: 1.15;
  letter-spacing: 0em;
  margin: 0 0 0.4em;

  @media screen and (min-width: ${props => props.theme.mediaQueryTresholds.M}) {
    font-size: 1.7em;
  }
  @media screen and (min-width: ${props =>
      props.theme.mediaQueryTresholds.XL}) {
    font-size: 2em;
  }
`

const Meta = styled.div`
  font-size: 0.9em;
  margin: 2rem 0 3rem;
`

const MetaItem = styled.div`
  background: ${props => props.theme.post.backgrounds.meta};
  border-left: 2px solid ${props => props.theme.post.colors.metaBorder};
  color: ${props => props.theme.post.colors.meta};
  padding: 0.3em 0.7em 0.4em;
`

const Content = styled.div`
  color: ${props => props.theme.post.colors.text};
  line-height: 1.5;

  .gatsby-resp-image-link {
    margin: 2.5em 0;
  }

  h2,
  h3 {
    color: ${props => props.theme.post.colors.title};
    font-size: 1.5em;
    font-weight: 700;
    line-height: 1.15;
    margin: 1em 0 0.7em;
    letter-spacing: -0.01em;

    @media screen and (min-width: ${props =>
        props.theme.mediaQueryTresholds.M}) {
      letter-spacing: -0.02em;
      font-size: 1.7em;
    }
    @media screen and (min-width: ${props =>
        props.theme.mediaQueryTresholds.XL}) {
      letter-spacing: -0.03em;
      font-size: 1.9em;
    }
  }

  p {
    margin: 0 0 1em;
    font-size: 1.05em;

    strong {
      letter-spacing: -0.01em;
      color: ${props => props.theme.post.colors.bold};
    }

    @media screen and (min-width: ${props =>
        props.theme.mediaQueryTresholds.M}) {
      font-size: 1.1em;
    }
    @media screen and (min-width: ${props =>
        props.theme.mediaQueryTresholds.XL}) {
      font-size: 1.2em;
    }
  }

  blockquote {
    border: 5px solid ${props => props.theme.post.colors.blockquoteFrame};
    font-style: italic;
    margin: 2.5em 0;
    padding: 1em 1.1em 1em 1.3em;
    position: relative;

    p {
      margin: 0;
    }

    &::after,
    &::before {
      background: ${props => props.theme.post.backgrounds.wrapper};
      content: '';
      height: 5px;
      left: 50%;
      margin-left: -47%;
      position: absolute;
      top: -5px;
      width: 94%;
    }
    &::after {
      top: auto;
      bottom: -5px;
    }

    @media screen and (min-width: ${props =>
        props.theme.mediaQueryTresholds.L}) {
      padding: 1em 1.8em 1em 2em;
    }
  }

  .gatsby-resp-image-link {
    margin-left: -1.5em;
    margin-right: -1.5em;
    border: none;

    @media screen and (min-width: ${props =>
        props.theme.mediaQueryTresholds.M}) {
      margin-left: -3.2em;
      margin-right: -3.2em;
    }
    @media screen and (min-width: ${props =>
        props.theme.mediaQueryTresholds.XL}) {
      margin-left: 0;
      margin-right: 0;
    }
  }
`

const Footer = styled.footer``

const Copyright = styled.p`
  color: ${props => props.theme.post.colors.copyright};
  font-size: 0.8em;
  padding: 4em 0 2em;
  text-align: right;
`
const Amazon = styled.img`
  height: 20px;
  width: 20px;
  margin: -5px 0;
`

const Twitter = styled.img`
  height: 25px;
  width: 25px;
  margin: 0 0 -5px 0;
`

const Article = ({post}) => {
  const {
    author,
    publication_date,
    rating,
    title,
    subTitle,
    url
  } = post.frontmatter
  return (
    <Wrapper>
      <Header>
        <Title>{title}</Title>
        <SubTitle>{subTitle}</SubTitle>
        <Meta>
          {/* <PostDate>{post.frontmatter.date}</PostDate> */}
          <MetaItem>
            Author{author && author.indexOf(',') > -1 ? 's' : ''}: {author}
          </MetaItem>
          <MetaItem>Publish Date: {publication_date}</MetaItem>
          <MetaItem>Rating: {rating}/10</MetaItem>
          <MetaItem>
            Amazon{' '}
            <Amazon
              alt="Amazon"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAATtSURBVGhD7VhbjBNVGD6ghMRLEAlKUNGoEU28hW47I1nTiO2Z0bZnCtmqEYLRhw3RCKLhAROzwRfkhaAkxESjL16iBoHd4g0SDfKAumKiIiSoUcODYrxFwcvCjN8//bd06d/tbtmZ7kO/5Mvp9Pz/f77/3GdUBx100EFL6M7lZlquuSfleOtT2tsK7rIc7xM8v2dp80rKKaxNaXNbItE7jV0mF2wnvwCid1iO+Q/Cg2ZEYj9Sst1uz2wO0V6k0+mzkcAmiPNPFzsWwvdXy/Xu5HDtAU0PTJd3JIHjojb/prKFRRw2fkDE5jpRLRLr5qitey7k0PHB0sUEBLQ0nUbhExw+PljaKwtCqsTc/wc2r6Onn8TU2YCFfViyq2XKMV9x+HiQyJRmQNiQJIYI8Z/budwlbF5BX99UJPe0ZF/Lm9LeBewRPVJZ0yOJCKm9YwszZi6bjoDrutOxPf8m+jHtO7wb2Dx6WE5hCabLSUkI+AabicD0+UjwqTLpeA6bxgPqdcstdoPLwtPaMVvoQOxy80k2EYFp96GUwCkWlrDp5EazRJLau5dNJwcS+fw5XY6Zn8yYLtsxmWFijXwhJTDMtieSvL04C+vmfiz27RD0PdjSGdO2RCpbsXkG2/HfkrDxsi2JVE5384MkqFXGngjt90jid0lMA/7FV/eGBykx1kToYIOgg5KQKrXZncwW7rN14Wo61dmVLpq0fmQfMNZEcF48IokIiSt50jWL2bQO8D0i+jHjTQSXO0lESO09xmYimk3H2BJJuYsvlQSExGik06Xz2LQOtMOJfjWMLxHH5CQBFZpv2EwE1osr+51i0jEr2Dxa4IqxXBJAxAZwmM1EINGXJb9aIsZ6No8W9KlHElBlpngdm44A3WpR3/y0194BdokWli5kRQFVmkGUV7C5ujGbPZc2AIzk8XrbBtTe3eweHaxFhYvR2Kg9C9EnIOYQfn/b7ACUCP+jdW+YUQBnwX5JwEQSybzIzUUH2iKlxsdO81mzqUYva9xchMCVA2LelQQ0pfbKdNbA/1Gpnqalrb2HuaXoEV7ftXlfEiORR2BdqVQ6i/yppPvYCDvtHcNIeGEDcYK++6JnV0FE44ug9n6m+b7QLV7FblVUTvpwl6NvWj/ZupjiqrZhCl3rbW2WhhdKXeyljwj0IWJ4BBqBX8weSmTy8/ivEEGfmuoPqFv9frUS3ITfG1GuDrap6tbeFHBa6peVeLDFgaCsboaGA8GACk4nknmJzZrD36FsOBxBsOcR9Er+Ozb4b6nZaPt6f7uai9/ToWEmNHlhIgPqBTYbG/xt6jI4fYqEhsBXwVu4KjbQNEK7a/ydqivoV/N4RFZz9dhBvQHHDUjoJPfGQXAtAl/DJhMO9P4ctPkg2tmL0kd5HKORB+8iHZjyl7Pp+IHe6EaQ/cPztJpUv9ocNtBi8GBQTaNOQazl4HPgoRFt9Ks9mF7zyRZ1r+G5HDqeCXgXeQDBvqttrKbRP8B93CDtMo+jXIMe7kW5kp7RIU+hfBbPb4Nfg0NirAH1JVh9XQ52qRmw/QX+1/JfZ46wF8tqGYIOSiJaJYSfgNidiO0GgZrCzYWgNYK6ND9OPGjYIWAd+HGj3h2N8PszFE9rYqu6iMO2F0jqfAjSELcK5RawDLEfhCMH4nkP+CbqN/J0W0Cjy+4ddNBBpFDqf1HNjGatjC9iAAAAAElFTkSuQmCC"
            />{' '}
            Link:{' '}
            <a href={url} target="_blank" rel="noopener">
              Affiliate
            </a>, <span> </span>
            <a href={url.split('?')[0]} target="_blank" rel="noopener">
              Non-Affiliate
            </a>{' '}
            {/* <Amazon src={amazon} alt="Amazon" /> */}
          </MetaItem>
        </Meta>
      </Header>
      <Content dangerouslySetInnerHTML={{__html: post.html}} />

      <div>
        <a
          href="https://twitter.com/share?ref_src=twsrc%5Etfw"
          className="twitter-share-button"
          target="_blank"
          data-size="large"
          data-via="latish"
          data-related="latish"
          data-show-count="false"
        >
          <Twitter src={twitter} />Share On Twitter
        </a>
        {/* <script
        async
        src="https://platform.twitter.com/widgets.js"
        charset="utf-8"
      /> */}
      </div>

      <MailChimp />
      <Footer>
        <Author />
        <Copyright>{config.copyright}</Copyright>
      </Footer>
    </Wrapper>
  )
}

export default Article



// WEBPACK FOOTER //
// ./src/components/Article/Article.jsx